import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  StructureArrow,
  StructureGrayButton,
  StructureNavigation
} from '../../../MyTeamBackofficeStyled';
import { Position, StructureType } from '../../../myTeamBackOffice.constants';
import AddNewMemberModal from '../../../common/AddNewMemberModal/AddNewMemberModal';
import {
  BackOnTopButton,
  DefaultPlacementButton,
  GoBottomButton,
  GoLeftDownArrowButton,
  GoRightDownArrowButton,
  GoUpArrowButton
} from '../../common';

import { motion } from 'framer-motion';
import { useAppSelector } from '../../../../../app/hooks';
import { Icon, IconStructureAddNewMember } from '../../../../../styles/Icons';
import { color } from '../../../../../styles/GlobalStyles';
import { Desktop } from '../../../../../App';

const StructureNav = () => {
  const { t } = useTranslation('myTeam');
  const { isCanadaRestrictedUser, user } = useAppSelector(
    (state) => state.auth.userInfo
  );

  return (
    <motion.div>
      <StructureNavigation>
        <Desktop>
          <GoUpArrowButton />
        </Desktop>
        <Desktop>
          <GoLeftDownArrowButton />
        </Desktop>
        <BackOnTopButton />
        <GoBottomButton
          position={Position.L}
          label={t('go_bottom_left')}
          isDisabled={false}
          structureType={StructureType.TEAM}
        />
        {!isCanadaRestrictedUser && (
          <StructureArrow
            orangeGradient
            onClick={() => {
              window.open(`/email-address/${user.id}`, '_blank');
            }}>
            <Icon color={color.colors.primary900}>
              <IconStructureAddNewMember />
            </Icon>
          </StructureArrow>
        )}

        <GoBottomButton
          position={Position.R}
          label={t('go_bottom_right')}
          isDisabled={false}
          structureType={StructureType.TEAM}
        />
        {!isCanadaRestrictedUser && <DefaultPlacementButton />}

        <Desktop>
          <GoUpArrowButton />
        </Desktop>
        <Desktop>
          <GoRightDownArrowButton />
        </Desktop>
      </StructureNavigation>
    </motion.div>
  );
};

export default StructureNav;
